import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ServicesService } from '~shared/servicios/services.service';
import { InicioNComponent } from '../inicio-n.component';

@Component({
  selector: 'app-beneficios',
  templateUrl: './beneficios.component.html',
  styleUrls: ['./beneficios.component.scss']
})
export class BeneficiosComponent extends InicioNComponent implements OnInit {


  Beneficios: any[] = [
    { titulo: 'Vender dropshipping', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Envíos a 1.100 municipios', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Recogida de mercancía', lvl1: false, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Proveedores públicos', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Proveedor privado', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Soporte preferencial', lvl1: false, lvl2: false, lvl3: false, lvl4: true, text: false },
    { titulo: 'Pronto pago', lvl1: 2, lvl2: 1.5, lvl3: 1.2, lvl4: 0.8, text: true },
    { titulo: 'Sms Bomber', lvl1: 0, lvl2: 500, lvl3: 2000, lvl4: 5000, text: true },
    { titulo: 'Sms agotados', lvl1: false, lvl2: false, lvl3: false, lvl4: true, text: false },
    { titulo: 'Tracking sms', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Conexión Shopify', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Venta cruzada Tracking', lvl1: false, lvl2: false, lvl3: false, lvl4: true, text: false },
    { titulo: 'Aceleración de dinero', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Reembolso de indemnizaciones', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Indemnizaciones rápidas', lvl1: false, lvl2: false, lvl3: false, lvl4: true, text: false },
    { titulo: 'Control y visibilidad financiera', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Reportes de ventas en tiempo real', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'CRM', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Config de varias cuentas bancarias', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Control contable', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Eventos públicos', lvl1: true, lvl2: true, lvl3: true, lvl4: true, text: false },
    { titulo: 'Eventos privados', lvl1: false, lvl2: false, lvl3: false, lvl4: true, text: false },
  ]

  niveles: any[] = [
    true, false, false, false
  ]

  constructor(public router: Router, public service: ServicesService, public cookieSvc: CookieService, public snackBar: MatSnackBar) {
    super(router, service, cookieSvc, snackBar);
  }

  ngOnInit(): void {
  }

  clickM() {
    this.service.emitChange(true);
  }

  selectBen(num: any): void {
    switch (num) {
      case 1:
        this.niveles.forEach((val: any, i) => {
          if (i === 0) {
            this.niveles[i] = true;
          } else {
            this.niveles[i] = false
          }
        });
        break;
      case 2:
        this.niveles.forEach((val: any, i) => {
          if (i === 1) {
            this.niveles[i] = true;
          } else {
            this.niveles[i] = false
          }
        });
        break;
      case 3:
        this.niveles.forEach((val: any, i) => {
          if (i === 2) {
            this.niveles[i] = true;
          } else {
            this.niveles[i] = false
          }
        });
        break;
      case 4:
        this.niveles.forEach((val: any, i) => {
          if (i === 3) {
            this.niveles[i] = true;
          } else {
            this.niveles[i] = false
          }
        });
        break;
    }
  }

  descargaWin(): void {
    window.open('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy.rar', '_blank');
  }

  descargaAnd(): void {
    window.open('https://play.google.com/store/apps/details?id=app.avalon.triidy', '_blank');
  }

}
